module.exports = __webpack_public_path__ + "static/media/home-apple-pay.130c927f.png";